import { mapState, mapGetters, mapActions } from 'vuex'
import Constants from '@/utils/Constants'
import AccountBox from '@/components/Core/Header/AccountBox'

export default {
  name: 'Header',
  components: {
    AccountBox
  },
  computed: {
    ...mapState({
      authorized: state => state.auth.authorized,
      activeAccount: state => state.core.activeAccount,
      activeDrawer: state => state.core.activeDrawer,
      activeGlobalMenu: state => state.core.activeGlobalMenu
    }),
    ...mapGetters({
      // userName: 'auth/userName',
      isSmartPhone: 'core/isSmartPhone',
      isTablet: 'core/isTablet',
      isDisplay: 'core/isDisplay'
    }),
    siteName () {
      return Constants.SiteInfo.name
    },
    showNavi () {
      return this.authorized
    },
    showDrawerNav () {
      // console.log('isSmartPhone : ', this.isSmartPhone)
      // console.log('isTablet : ', this.isTablet)
      // console.log('isDisplay : ', this.isDisplay)
      return this.isSmartPhone || this.isTablet
    },
    showToggleMenu () {
      return this.isDisplay
    },
    isHomePage () {
      return this.$route.name === 'Home'
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hideAccount()
      this.hideDrawer()
    }
  },
  methods: {
    ...mapActions({
      showAccount: 'core/showAccount',
      hideAccount: 'core/hideAccount',
      showDrawer: 'core/showDrawer',
      hideDrawer: 'core/hideDrawer',
      toggleGlobalMenu: 'core/toggleGlobalMenu'
    }),
    /**
     * アカウントボックスの表示切替
     */
    toggleAccount () {
      this.activeAccount ?
        this.hideAccount() : this.showAccount()

      if (this.activeAccount && this.activeDrawer) {
        this.hideDrawer()
      }
    },
    /**
     * ドロワーメニューの表示切替
     */
    toggleDrawer () {
      this.activeDrawer ?
        this.hideDrawer() : this.showDrawer()
        
      if (this.activeAccount && this.activeDrawer) {
        this.hideAccount()
      }
    }
  }
}